import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Just for fun 👉 React vs. jQuery vs. Svelte, same 🐱 app",
  "description": "",
  "published": "2019-05-24T00:00:00.000Z",
  "redirect_from": ["/blog/just-for-fun-%f0%9f%91%89-react-vs-jquery-vs-svelte-same-%f0%9f%90%b1-app/swizec/9093"],
  "categories": "Front End, Livecoding, Technical",
  "hero": "./img/techletter.app-screenshot-1558716298013.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You know that feeling when you meet an old friend you haven't seen in years? You used to be so close but ...`}</p>
    <p><em parentName="p">{`"Long time huh ..."`}</em></p>
    <p><em parentName="p">{`"Yeah time flies ... how's the wife?"`}</em></p>
    <p><em parentName="p">{`"Girlfriend. She's good, just started a new job ..."`}</em></p>
    <p><em parentName="p">{`"Nice nice ... you still at that startup?"`}</em></p>
    <p><em parentName="p">{`"Yeah ... it's okay ... you?"`}</em></p>
    <p><em parentName="p">{`"Nah, new gig last year. Think I told you, dunno"`}</em></p>
    <p><em parentName="p">{`"Maybe you did, hard to keep track ... liking it?"`}</em></p>
    <p>{`A beer or two later and you're back to being best buds. Suddenly it's 1am and a long yawn reminds you that you're not quite so young anymore.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1131635031573639169"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.677130044843054%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'255\\'%20viewBox=\\'0%200%20400%20255\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2021c-5%203-7%208-7%2014l2%206%201%201c0%203%206%206%2010%207%204%200%206%200%209-2%205-2%205-4%201-4l-3-2c0-2%202-4%205-4l2-1%202-1%201-2c0-10-14-18-23-12m41%20175c-2%203-3%208-1%2010h13v-4c0-7-7-10-12-6m38-1l-1%203-2%204c-2%203%202%207%207%207%206-1%209-7%203-7-2%200-2%200-2-3l2-2c3%201%202-1-1-2h-6m-20%202c-4%203-1%2012%205%2012%203%200%207-4%207-7%202-6-6-9-12-5m37%200c-4%205-1%2012%205%2012%207-1%206-13-1-14-2%200-3%200-4%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ea28ceae47f2d057e0b6268b8657bc0d/ca0a1/techletter.app-screenshot-1558716298013.webp 223w", "/static/ea28ceae47f2d057e0b6268b8657bc0d/75680/techletter.app-screenshot-1558716298013.webp 445w", "/static/ea28ceae47f2d057e0b6268b8657bc0d/0ba47/techletter.app-screenshot-1558716298013.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ea28ceae47f2d057e0b6268b8657bc0d/e92b6/techletter.app-screenshot-1558716298013.png 223w", "/static/ea28ceae47f2d057e0b6268b8657bc0d/e66bf/techletter.app-screenshot-1558716298013.png 445w", "/static/ea28ceae47f2d057e0b6268b8657bc0d/6af66/techletter.app-screenshot-1558716298013.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ea28ceae47f2d057e0b6268b8657bc0d/6af66/techletter.app-screenshot-1558716298013.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`That's what messing around with jQuery felt like after all these years.`}</p>
    <p>{`I was bored Monday night and decided to see if I still know how to build with jQuery. Nothing better to do, no pressing ideas, a bit of fun.`}</p>
    <p>{`Also a favor for a friend who's preparing to talk about React to a bunch of people who've never seen it before 😛`}</p>
    <lite-youtube {...{
      "videoid": "BP1I28jWuOY",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`It's funny, jQuery is so old now (2 years since new versions stopped coming) I feel like I almost have to introduce the darn thing. Used to be the backbone of the web, now it's in the dustbin of history.`}</p>
    <p>{`Pushed web development forward for its entire 10 year run. Oh the memories ...`}</p>
    <p><img parentName="p" {...{
        "src": "/8070e94e274898ee1e050e951cd2a8e7/media-kcSG1rpAKxpao-giphy.gif",
        "alt": "memory_lane giphy"
      }}></img></p>
    <p>{`So, how does jQuery stack up to React and how does React stack up to Svelte? Let's see 👇`}</p>
    <h2 {...{
      "id": "react-app"
    }}>{`React app`}</h2>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/optimistic-sanderson-or99s"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h171V15H229v98m54-69v3l1-1h10l1%203c1%203%200%203-8%200h-4l2%201%201%201-2%201c-1%200-2%204-2%2015%200%2015%200%2016%202%2016v1c-1%201%205%201%2019%201%2020%200%2025-1%2025-4l2-1%201%202c0%203%200%203%208%203l8-1V43l-32-1c-31%200-32%200-32%202m45%2010v2l-1-1-2-1%201%202c1%202%201%202-1%202-3%200-3%200-3%202h-6l1%201%203%204%202%203%201%202h1l2-1%203-1%203-7%201-1%202-3c2-2%201-3-4-3h-3M3%20120v5h51v-5H3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c97417a11f50867562b1206a4bfb3d15/ca0a1/techletter.app-screenshot-1558716236871.webp 223w", "/static/c97417a11f50867562b1206a4bfb3d15/75680/techletter.app-screenshot-1558716236871.webp 445w", "/static/c97417a11f50867562b1206a4bfb3d15/0ba47/techletter.app-screenshot-1558716236871.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c97417a11f50867562b1206a4bfb3d15/e92b6/techletter.app-screenshot-1558716236871.png 223w", "/static/c97417a11f50867562b1206a4bfb3d15/e66bf/techletter.app-screenshot-1558716236871.png 445w", "/static/c97417a11f50867562b1206a4bfb3d15/6af66/techletter.app-screenshot-1558716236871.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c97417a11f50867562b1206a4bfb3d15/6af66/techletter.app-screenshot-1558716236871.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Started with a React app. It's what I'm most familiar with right now.`}</p>
    <p>{`We built a cat app. Fetches 5 cats from `}<a parentName="p" {...{
        "href": "https://thecatapi.com/"
      }}>{`thecatapi`}</a>{`, shows first cat. Click a button, get more cats.`}</p>
    <p>{`When app runs out of cats, it fetches more.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20fetchCats(currentCount)%20%7B%0A%20%20const%20page%20%3D%20Math.ceil(currentCount%20%2F%205)%3B%0A%20%20return%20fetch(%0A%20%20%20%20%60https%3A%2F%2Fapi.thecatapi.com%2Fv1%2Fimages%2Fsearch%3Flimit%3D5%26page%3D%24%7Bpage%7D%26order%3DDesc%60%0A%20%20).then(response%20%3D%3E%20response.json())%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "742px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "37.21973094170403%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'149\\'%20viewBox=\\'0%200%20400%20149\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M18%2027c-2%201-1%2094%200%2096%202%202%20362%202%20364%200l1-49V27l-183-1-182%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4e43881b942df86dc862adc45dfb9028/ca0a1/techletter.app-screenshot-1558716386063.webp 223w", "/static/4e43881b942df86dc862adc45dfb9028/75680/techletter.app-screenshot-1558716386063.webp 445w", "/static/4e43881b942df86dc862adc45dfb9028/28367/techletter.app-screenshot-1558716386063.webp 742w"],
                "sizes": "(max-width: 742px) 100vw, 742px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4e43881b942df86dc862adc45dfb9028/e92b6/techletter.app-screenshot-1558716386063.png 223w", "/static/4e43881b942df86dc862adc45dfb9028/e66bf/techletter.app-screenshot-1558716386063.png 445w", "/static/4e43881b942df86dc862adc45dfb9028/0f2bc/techletter.app-screenshot-1558716386063.png 742w"],
                "sizes": "(max-width: 742px) 100vw, 742px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/4e43881b942df86dc862adc45dfb9028/0f2bc/techletter.app-screenshot-1558716386063.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><inlineCode parentName="p">{`fetchCats`}</inlineCode>{` returns a promise with a bunch of cats. Pagination works based on current count of cats we've got.`}</p>
    <p>{`Rendering a list of cats happens in a `}<inlineCode parentName="p">{`<Kitties />`}</inlineCode>{` component. 'tis but a loop`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20Kitties(%7B%20cats%2C%20count%20%7D)%20%7B%0A%20%20return%20(%0A%20%20%20%20%3C%3E%0A%20%20%20%20%20%20%7Bcats.slice(0%2C%20count).map(cat%20%3D%3E%20(%0A%20%20%20%20%20%20%20%20%3Cdiv%20key%3D%7Bcat.id%7D%3E%0A%20%20%20%20%20%20%20%20%20%20%3Cimg%20src%3D%7Bcat.url%7D%20alt%3D%22Cat%20image%22%20%2F%3E%0A%20%20%20%20%20%20%20%20%3C%2Fdiv%3E%0A%20%20%20%20%20%20))%7D%0A%20%20%20%20%3C%2F%3E%0A%20%20)%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "478px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "76.68161434977578%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'307\\'%20viewBox=\\'0%200%20400%20307\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M28%2041l-1%20113c0%20110%200%20112%202%20113h342c2-1%202-3%202-113l-1-113c-2-2-342-2-344%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/80142a1119384365d503ee4e9d8ff2f1/ca0a1/techletter.app-screenshot-1558716225020.webp 223w", "/static/80142a1119384365d503ee4e9d8ff2f1/75680/techletter.app-screenshot-1558716225020.webp 445w", "/static/80142a1119384365d503ee4e9d8ff2f1/2b263/techletter.app-screenshot-1558716225020.webp 478w"],
                "sizes": "(max-width: 478px) 100vw, 478px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/80142a1119384365d503ee4e9d8ff2f1/e92b6/techletter.app-screenshot-1558716225020.png 223w", "/static/80142a1119384365d503ee4e9d8ff2f1/e66bf/techletter.app-screenshot-1558716225020.png 445w", "/static/80142a1119384365d503ee4e9d8ff2f1/50978/techletter.app-screenshot-1558716225020.png 478w"],
                "sizes": "(max-width: 478px) 100vw, 478px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/80142a1119384365d503ee4e9d8ff2f1/50978/techletter.app-screenshot-1558716225020.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Take list of `}<inlineCode parentName="p">{`cats`}</inlineCode>{`, `}<inlineCode parentName="p">{`count`}</inlineCode>{` how many the user wants to see, `}<inlineCode parentName="p">{`slice`}</inlineCode>{` the array, render each cat as an image. 👌`}</p>
    <p>{`Driving this logic with React Hooks isn't bad. React's ergonomics are getting real good.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20App()%20%7B%0A%20%20const%20%5BshowCount%2C%20setShowCount%5D%20%3D%20useState(1)%3B%0A%20%20const%20%5Bcats%2C%20setCats%5D%20%3D%20useState(%5B%5D)%3B%0A%0A%20%20useEffect(()%20%3D%3E%20%7B%0A%20%20%20%20if%20(cats.length%20%3C%20showCount)%20%7B%0A%20%20%20%20%20%20fetchCats(showCount).then(newCats%20%3D%3E%20setCats(%5B...cats%2C%20...newCats%5D))%3B%0A%20%20%20%20%7D%0A%20%20%7D%2C%20%5Bcats%2C%20showCount%5D)%3B%0A%0A%20%20const%20moreCats%20%3D%20()%20%3D%20%3E%20%7B%0A%20%20%20%20setShowCount(showCount%20%2B%201)%3B%0A%20%20%7D%3B%0A%0A%20%20return%20(%0A%20%20%20%20%3Cdiv%20className%3D%22App%22%3E%0A%20%20%20%20%20%20%3Ch1%20%3EThese%20are%20cats.%3C%2Fh1%20%3E%0A%20%20%20%20%20%20%3Ch2%20%3ECats%20are%20cool%20%3C%2Fh2%3E%0A%20%20%20%20%20%20%3CKitties%20cats%3D%7Bcats%7D%20count%3D%7BshowCount%7D%20%2F%3E%0A%20%20%20%20%20%20%3Cbutton%20onClick%3D%7BmoreCats%7D%20%3EMore%20cats!%20%3C%2Fbutton%20%3E%0A%20%20%20%20%3C%2Fdiv%20%3E%0A%20%20)%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "702px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "82.95964125560539%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'332\\'%20viewBox=\\'0%200%20400%20332\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M19%2028l-1%20139%201%20137%203%201a12878%2012878%200%2000357%200l3-1V167l-1-139c-2-2-360-2-362%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8cec8e302fbec3223475a5d0f010634a/ca0a1/techletter.app-screenshot-1558716519892.webp 223w", "/static/8cec8e302fbec3223475a5d0f010634a/75680/techletter.app-screenshot-1558716519892.webp 445w", "/static/8cec8e302fbec3223475a5d0f010634a/de2ca/techletter.app-screenshot-1558716519892.webp 702w"],
                "sizes": "(max-width: 702px) 100vw, 702px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8cec8e302fbec3223475a5d0f010634a/e92b6/techletter.app-screenshot-1558716519892.png 223w", "/static/8cec8e302fbec3223475a5d0f010634a/e66bf/techletter.app-screenshot-1558716519892.png 445w", "/static/8cec8e302fbec3223475a5d0f010634a/d6331/techletter.app-screenshot-1558716519892.png 702w"],
                "sizes": "(max-width: 702px) 100vw, 702px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/8cec8e302fbec3223475a5d0f010634a/d6331/techletter.app-screenshot-1558716519892.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`We got `}<inlineCode parentName="p">{`useState`}</inlineCode>{` for the count of cats, and a `}<inlineCode parentName="p">{`useEffect`}</inlineCode>{` to deal with fetching. Fetches on first load and makes sure to fetch more when `}<inlineCode parentName="p">{`showCount`}</inlineCode>{` is bigger than the current amount of cats.`}</p>
    <p>{`React handles the rest.`}</p>
    <p><img parentName="p" {...{
        "src": "/9a021a6cd72cfaab539f3b1fef648ed9/media-12NUbkX6p4xOO4-giphy.gif",
        "alt": "magic giphy"
      }}></img></p>
    <h2 {...{
      "id": "jquery-app"
    }}>{`jQuery app`}</h2>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/priceless-surf-d5mhb"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h171V15H229v98m69-67c1%209%202%2015%201%2016v2l-2%201c-2%200-2%200-1%201%202%200%203%206%202%207%200%201-2%200-3-2l-1-4c1-1-1-1-4-1-7%201-8%202-8%2015v10h23c22%200%2024%200%2025-2h1l2%202c2%200%203-4%201-4h-5l-1-2v-6l2-2%201-6c1-6%200-9-5-12-2-2-3-3-3-6s0-4-1-3c0%202-1%202-3%202-4-1-4-1-4%204l-1%2014-2-4%201-5v-5c1-2%201-2-1-1s-2%201-2-5v-7h-13l1%203M3%20104v2h51v-5H3v3m-1%2084v11h21v-22H2v11\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/87216af8a41360c91e86f9419908b5ff/ca0a1/techletter.app-screenshot-1558716240030.webp 223w", "/static/87216af8a41360c91e86f9419908b5ff/75680/techletter.app-screenshot-1558716240030.webp 445w", "/static/87216af8a41360c91e86f9419908b5ff/0ba47/techletter.app-screenshot-1558716240030.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/87216af8a41360c91e86f9419908b5ff/e92b6/techletter.app-screenshot-1558716240030.png 223w", "/static/87216af8a41360c91e86f9419908b5ff/e66bf/techletter.app-screenshot-1558716240030.png 445w", "/static/87216af8a41360c91e86f9419908b5ff/6af66/techletter.app-screenshot-1558716240030.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/87216af8a41360c91e86f9419908b5ff/6af66/techletter.app-screenshot-1558716240030.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The hardest part of building the jQuery version was figuring out how to import jQuery in a modern compiled-JavaScript app. 😂`}</p>
    <p>{`No seriously, I struggled, tried a bunch of things, and ended up with a good old script tag and a public CDN.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=html&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%3Cscript%20src%3D%22https%3A%2F%2Fcode.jquery.com%2Fjquery-3.4.1.slim.min.js%22%20integrity%3D%22sha256-pasqAKBDmFT4eHoN2ndd6lN370kFiGUFyTiUHWhU7k8%3D%22%0A%09%20crossorigin%3D%22anonymous%22%3E%3C%2Fscript%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "21.973094170403588%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'87\\'%20viewBox=\\'0%200%20400%2087\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%2023c-2%207-1%2044%200%2045%202%202%20372%202%20374%200%201-1%202-38%200-45v-4H13v4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4d922274d6023d18133628222b5e6c23/ca0a1/techletter.app-screenshot-1558716568077.webp 223w", "/static/4d922274d6023d18133628222b5e6c23/75680/techletter.app-screenshot-1558716568077.webp 445w", "/static/4d922274d6023d18133628222b5e6c23/8d1ba/techletter.app-screenshot-1558716568077.webp 890w", "/static/4d922274d6023d18133628222b5e6c23/a9a89/techletter.app-screenshot-1558716568077.webp 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4d922274d6023d18133628222b5e6c23/e92b6/techletter.app-screenshot-1558716568077.png 223w", "/static/4d922274d6023d18133628222b5e6c23/e66bf/techletter.app-screenshot-1558716568077.png 445w", "/static/4d922274d6023d18133628222b5e6c23/4ef49/techletter.app-screenshot-1558716568077.png 890w", "/static/4d922274d6023d18133628222b5e6c23/2bef9/techletter.app-screenshot-1558716568077.png 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/4d922274d6023d18133628222b5e6c23/4ef49/techletter.app-screenshot-1558716568077.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`People don't do that in real life anymore. It's all import this import that.`}</p>
    <p>{`For the app itself we used a naive unoptimized approach much like many jQuery apps of old 👉 find div, empty div, render everything from scratch every time.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20renderCats(cats%2C%20count)%20%7B%0A%20%20%24(%22%23kitties%22).html(%22%22)%3B%0A%0A%20%20cats.slice(0%2C%20count).forEach(cat%20%3D%3E%20%7B%0A%20%20%20%20%24(%22%23kitties%22).append(%24(%22%3Cdiv%20%3E%22).append(%24(%22%3Cimg%3E%22).attr(%22src%22%2C%20cat.url)))%3B%0A%20%20%7D)%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "726px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "40.80717488789237%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'163\\'%20viewBox=\\'0%200%20400%20163\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M18%2028v55l1%2054h363V28l-182-1-182%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/49a0dc84576fb1c6e2558467c018b306/ca0a1/techletter.app-screenshot-1558716611709.webp 223w", "/static/49a0dc84576fb1c6e2558467c018b306/75680/techletter.app-screenshot-1558716611709.webp 445w", "/static/49a0dc84576fb1c6e2558467c018b306/06b0e/techletter.app-screenshot-1558716611709.webp 726w"],
                "sizes": "(max-width: 726px) 100vw, 726px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/49a0dc84576fb1c6e2558467c018b306/e92b6/techletter.app-screenshot-1558716611709.png 223w", "/static/49a0dc84576fb1c6e2558467c018b306/e66bf/techletter.app-screenshot-1558716611709.png 445w", "/static/49a0dc84576fb1c6e2558467c018b306/f8067/techletter.app-screenshot-1558716611709.png 726w"],
                "sizes": "(max-width: 726px) 100vw, 726px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/49a0dc84576fb1c6e2558467c018b306/f8067/techletter.app-screenshot-1558716611709.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Notice the mess with creating a small component tree of `}<inlineCode parentName="p">{`<div><img></div>`}</inlineCode>{`? Painful. JSX improved this a lot. Almost can't believe we used to build complex apps like this.`}</p>
    <p>{`You can see it's slow too.`}</p>
    <p>{`Open `}<a parentName="p" {...{
        "href": "https://codesandbox.io/s/priceless-surf-d5mhb"
      }}>{`the CodeSandbox`}</a>{`, add a couple cats. You'll see the more cats there are the slower the app gets.`}</p>
    <p>{`Not so with React because React avoids re-rendering components that don't change.`}</p>
    <p>{`PS: check out this mess of attaching a button click handler and driving the cat fetching logic.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%24(%22button%22).on(%22click%22%2C%20()%20%3D%3E%20%7B%0A%20%20CatCount%20%2B%3D%201%3B%0A%0A%20%20if%20(CatCount%20%3E%20Cats.length)%20%7B%0A%20%20%20%20%2F%2F%20Fetch%20more%20cats%20when%20we%20run%20out%0A%20%20%20%20fetchCats(CatCount).then(newCats%20%3D%3E%20%7B%0A%20%20%20%20%20%20Cats%20%3D%20%5B...Cats%2C%20...newCats%5D%3B%0A%20%20%20%20%20%20renderCats(Cats%2C%20CatCount)%3B%0A%20%20%20%20%7D)%3B%0A%20%20%7D%20else%20%7B%0A%20%20%20%20renderCats(Cats%2C%20CatCount)%3B%0A%20%20%7D%0A%7D)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "430px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "93.72197309417041%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'375\\'%20viewBox=\\'0%200%20400%20375\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2046c-2%202-1%20282%201%20284s334%202%20336%200%203-282%201-284-336-2-338%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/495728e8234e0f8bd00d4dda57e0d108/ca0a1/techletter.app-screenshot-1558716220837.webp 223w", "/static/495728e8234e0f8bd00d4dda57e0d108/866c5/techletter.app-screenshot-1558716220837.webp 430w"],
                "sizes": "(max-width: 430px) 100vw, 430px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/495728e8234e0f8bd00d4dda57e0d108/e92b6/techletter.app-screenshot-1558716220837.png 223w", "/static/495728e8234e0f8bd00d4dda57e0d108/05ed2/techletter.app-screenshot-1558716220837.png 430w"],
                "sizes": "(max-width: 430px) 100vw, 430px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/495728e8234e0f8bd00d4dda57e0d108/05ed2/techletter.app-screenshot-1558716220837.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`🤮`}</p>
    <p>{`I like hooks.`}</p>
    <h2 {...{
      "id": "svelte-app"
    }}>{`Svelte app`}</h2>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/infallible-monad-wq5j9"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h171V15H229v98m53-70v25l1%2024h16l19-1h1l14%201h14V43l-32-1-33%201m34%2010v1l-1%203-3%203c-3%201-3%201-2%202v1l-7%203h3l3%201%201%202%201-1h2v1l-1%202%202-1c0-1%201-1%202%201%202%203%204%202%205-1l1-3v3c0%202%200%202%202%201v-4l-2-1c-1-1-1-1%202-1l3%201v-4l-2-6-1-3h-8M3%20104v2h51v-5H3v3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/239afe8fbfbc1e308c2d7a99e13dafb6/ca0a1/techletter.app-screenshot-1558716652847.webp 223w", "/static/239afe8fbfbc1e308c2d7a99e13dafb6/75680/techletter.app-screenshot-1558716652847.webp 445w", "/static/239afe8fbfbc1e308c2d7a99e13dafb6/0ba47/techletter.app-screenshot-1558716652847.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/239afe8fbfbc1e308c2d7a99e13dafb6/e92b6/techletter.app-screenshot-1558716652847.png 223w", "/static/239afe8fbfbc1e308c2d7a99e13dafb6/e66bf/techletter.app-screenshot-1558716652847.png 445w", "/static/239afe8fbfbc1e308c2d7a99e13dafb6/6af66/techletter.app-screenshot-1558716652847.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/239afe8fbfbc1e308c2d7a99e13dafb6/6af66/techletter.app-screenshot-1558716652847.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The Svelte version wins in the immense straightforward simplicity of it all. I'm pretty blown away.`}</p>
    <p>{`Check out the `}<inlineCode parentName="p">{`<Kitty />`}</inlineCode>{` component`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%3Cscript%3E%0A%20%20%20%20export%20let%20id%3B%0A%20%20%20%20export%20let%20url%3B%0A%3C%2Fscript%3E%0A%0A%3Cstyle%20%3E%0A%20%20%20%20img%20%7B%0A%20%20%20%20%20%20width%3A%20300px%3B%0A%20%20%20%20%7D%0A%3C%2Fstyle%3E%0A%0A%3Cdiv%3E%0A%20%20%20%20%3Cimg%20src%3D%7Burl%7D%20alt%3D%22Kitty%20pic%22%20%2F%3E%0A%3C%2Fdiv%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "398px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "105.82959641255604%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'423\\'%20viewBox=\\'0%200%20400%20423\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M34%2050c-2%202-1%20323%201%20325s329%202%20331%200%203-323%201-325-331-2-333%200m36%2016c-4%203-1%2010%204%2010l4-2%202-4c0-5-7-8-10-4m20%200c-3%203-3%205%200%208%204%203%204%203%208-1%201-1%202-3%201-4-1-5-6-6-9-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fdf1c30ee32522fe8899afe568c55974/ca0a1/techletter.app-screenshot-1558716705186.webp 223w", "/static/fdf1c30ee32522fe8899afe568c55974/579c2/techletter.app-screenshot-1558716705186.webp 398w"],
                "sizes": "(max-width: 398px) 100vw, 398px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fdf1c30ee32522fe8899afe568c55974/e92b6/techletter.app-screenshot-1558716705186.png 223w", "/static/fdf1c30ee32522fe8899afe568c55974/692d4/techletter.app-screenshot-1558716705186.png 398w"],
                "sizes": "(max-width: 398px) 100vw, 398px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/fdf1c30ee32522fe8899afe568c55974/692d4/techletter.app-screenshot-1558716705186.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Gets an `}<inlineCode parentName="p">{`id`}</inlineCode>{` and a `}<inlineCode parentName="p">{`url`}</inlineCode>{`, has some `}<inlineCode parentName="p">{`style`}</inlineCode>{`, and renders a div with an image. Pretty slick, looks almost like pure HTML.`}</p>
    <p>{`Then you got the component that drives state and renders a bunch of kitties with a button.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%3Cscript%3E%0A%20%20import%20Kitty%20from%20%22.%2FKitty.svelte%22%3B%0A%20%20let%20showCount%20%3D%201%3B%0A%20%20let%20cats%20%3D%20%5B%5D%3B%0A%0A%20%20function%20fetchCats(currentCount)%20%7B%0A%20%20%20%20const%20page%20%3D%20Math.ceil(currentCount%20%2F%205)%3B%0A%20%20%20%20return%20fetch(%0A%20%20%20%20%20%20%60https%3A%2F%2Fapi.thecatapi.com%2Fv1%2Fimages%2Fsearch%3Flimit%3D5%26page%3D%24%7Bpage%7D%26order%3DDesc%60%0A%20%20%20%20).then(response%20%3D%3E%20response.json())%3B%0A%20%20%7D%0A%0A%20%20fetchCats(showCount).then(newCats%20%3D%3E%20%7B%0A%20%20%20%20cats%20%3D%20%5B...cats%2C%20...newCats%5D%3B%0A%20%20%7D)%3B%0A%0A%20%20function%20moreCats()%20%7B%0A%20%20%20%20showCount%20%2B%3D%201%3B%0A%0A%20%20%20%20if%20(showCount%3E%20%20cats.length)%20%7B%0A%20%20%20%20%20%20fetchCats(showCount).then(newCats%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20cats%20%3D%20%5B...cats%2C%20...newCats%5D%3B%0A%20%20%20%20%20%20%7D)%3B%0A%20%20%20%20%7D%0A%20%20%7D%0A%3C%2Fscript%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "758px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "83.85650224215246%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'336\\'%20viewBox=\\'0%200%20400%20336\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M18%2026l-1%20143%201%20142h365V169l-1-143H18\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c56f9dfb1e99ee04c0f1ca8c7b3c7ce2/ca0a1/techletter.app-screenshot-1558716776602.webp 223w", "/static/c56f9dfb1e99ee04c0f1ca8c7b3c7ce2/75680/techletter.app-screenshot-1558716776602.webp 445w", "/static/c56f9dfb1e99ee04c0f1ca8c7b3c7ce2/c4e8e/techletter.app-screenshot-1558716776602.webp 758w"],
                "sizes": "(max-width: 758px) 100vw, 758px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c56f9dfb1e99ee04c0f1ca8c7b3c7ce2/e92b6/techletter.app-screenshot-1558716776602.png 223w", "/static/c56f9dfb1e99ee04c0f1ca8c7b3c7ce2/e66bf/techletter.app-screenshot-1558716776602.png 445w", "/static/c56f9dfb1e99ee04c0f1ca8c7b3c7ce2/c8e86/techletter.app-screenshot-1558716776602.png 758w"],
                "sizes": "(max-width: 758px) 100vw, 758px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c56f9dfb1e99ee04c0f1ca8c7b3c7ce2/c8e86/techletter.app-screenshot-1558716776602.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The script looks similar to React Hooks. You got some variables with state and you got a `}<inlineCode parentName="p">{`moreCats`}</inlineCode>{` method that drives it.`}</p>
    <p>{`Repeating that array merging logic twice is a little less elegant than the `}<inlineCode parentName="p">{`useEffect`}</inlineCode>{` hook, but probably easier to understand how it works 🤔`}</p>
    <p>{`Rendering is neat too`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%3Cmain%3E%0A%09%3Ch1%20%3EThese%20are%20cats.%3C%2Fh1%20%3E%0A%20%20%3Ch2%3ECats%20are%20cool%20%F0%9F%98%B8%3C%2Fh2%3E%0A%09%7B%23each%20cats.slice(0%2C%20showCount)%20as%20%7Bid%2C%20url%7D%7D%0A%20%20%20%20%3CKitty%20id%3D%7Bid%7D%20url%3D%7Burl%7D%20%2F%3E%0A%20%20%7B%2Feach%7D%0A%20%20%3Cbutton%20on%3Aclick%3D%7BmoreCats%7D%3EMore%20cats!%20%3C%2Fbutton%20%3E%0A%3C%2Fmain%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "510px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "61.43497757847533%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'245\\'%20viewBox=\\'0%200%20400%20245\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M27%2039c-2%201-2%2010-2%2084v83l2%201c4%203%20342%203%20346%200l2-1v-83c0-74%200-83-2-84-2-3-344-3-346%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d753a0088a34c3ab4023220bdea51ff3/ca0a1/techletter.app-screenshot-1558716843947.webp 223w", "/static/d753a0088a34c3ab4023220bdea51ff3/75680/techletter.app-screenshot-1558716843947.webp 445w", "/static/d753a0088a34c3ab4023220bdea51ff3/b7235/techletter.app-screenshot-1558716843947.webp 510w"],
                "sizes": "(max-width: 510px) 100vw, 510px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d753a0088a34c3ab4023220bdea51ff3/e92b6/techletter.app-screenshot-1558716843947.png 223w", "/static/d753a0088a34c3ab4023220bdea51ff3/e66bf/techletter.app-screenshot-1558716843947.png 445w", "/static/d753a0088a34c3ab4023220bdea51ff3/0abdd/techletter.app-screenshot-1558716843947.png 510w"],
                "sizes": "(max-width: 510px) 100vw, 510px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d753a0088a34c3ab4023220bdea51ff3/0abdd/techletter.app-screenshot-1558716843947.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Similar to React, but we used `}<inlineCode parentName="p">{`{#each}`}</inlineCode>{` instead of JavaScript's `}<inlineCode parentName="p">{`.map`}</inlineCode>{`. Still not sure how I feel about that but it's pretty readable you gotta admit.`}</p>
    <h2 {...{
      "id": ""
    }}>{`🤔`}</h2>
    <p>{`Between you and me I think React wins this one. Maybe it's because I'm used to it.`}</p>
    <p>{`But Svelte does look like it might be quicker to grasp for someone who's new to modern JavaScript.`}</p>
    <p>{`What do you think?`}</p>
    <p>{`Happy Friday,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      